<template>
    <div>
        <Component
            :is="link.url ? 'Link' : 'span'"
            class="inline-block p-2 border border-slate-300 opacity-100 bg-white"
            v-for="link in links"
            :href="link.url"
            v-html="link.label"
            :class="{'text-gray-500 ' : !link.url , 'font-bold' : link.active}"
            />
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
export default {
    props: {
        links: Array
    },
    components:{Link}
}
</script>

<style scoped>

</style>
